import { render, staticRenderFns } from "./CustomerContacts.vue?vue&type=template&id=77cf5fd2&"
import script from "./CustomerContacts.vue?vue&type=script&lang=js&"
export * from "./CustomerContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports